export default {
  actions: {},
  getters: {
    filterByAttributeValue: state => (attribute, value) => {
      if (!attribute) {
        return [];
      }

      return state.list.filter(item => {
        if (item[attribute] === undefined) {
          return false;
        }

        return item[attribute] === value;
      });
    },
    getById: state => findId => {
      return state.list.find(item => {
        return item.id === findId;
      });
    },
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
    setRecord(state, record) {
      state.record = record;
    },
  },
  namespaced: true,
  state: {
    list: [
      {
        callback(list, item) {
          return list.includes(item);
        },
        name: "contains",
        symbol: "[...]",
      },
      {
        callback(list, item) {
          return !list.includes(item);
        },
        name: "does not contain",
        symbol: "![...]",
      },
    ],
    record: null,
  },
};
